@if (!showAuthenticatorSetup()) {
    <div class="mfa-enrollment-required-content">
        <app-message-box level="info" [messages]="{message: 'For added security, some connected carriers require two-step verification. Once you set this up, you\'ll use it each time you log in.'}"></app-message-box>

        <p class="suif-body-copy-bold enrollment-instructions">Select a Verification Method</p>

        <div class="verification-method-options">
            <div class="verification-method-option suif-disabled">
                <app-radio
                    name="mfaEnrollmentMethod"
                    radioValue="SMS"
                    label="Text Message"
                    [isDisabled]="true">
                </app-radio>
                <p class="suif-body-copy-small option-description">
                    Get verification codes sent directly to your phone via text message (SMS) to verify your identity.
                </p>
            </div>

            <div class="verification-method-option">
                <app-radio
                    name="mfaEnrollmentMethod"
                    radioValue="AUTHENTICATOR"
                    label="Authenticator App"
                    [(ngModel)]="selectedMethod">
                </app-radio>
                <p class="suif-body-copy-small option-description">
                    You can use a phone app like Google Authenticator or Microsoft Authenticator to get verification
                    codes. <a [href]="authenticatorLearnMoreUrl()" target="_blank" rel="noopener noreferrer">Learn More</a>
                </p>
            </div>
        </div>

        <div class="button-row">
            <button
                type="button"
                class="btn btn-verty"
                [disabled]="selectedMethod !== 'AUTHENTICATOR'"
                (click)="continue()">
                Continue
            </button>
        </div>
    </div>
} @else {
    <app-mfa-authenticator-setup
        [showCancelButton]="false"
        [skipPasswordReAuth]="true"
        (verified)="verified.emit()">
    </app-mfa-authenticator-setup>
}
